import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import type { Audit } from '@/models/registry';
import dayjs from 'dayjs';
import AuditIcon from './audit-icon';
import UserProfileCard from './user-profile-card';

const AuditLine = ({ audit }: { audit: Audit }) => {
  const { created_by, created_at, id, message } = audit;
  return (
    <div key={id} className="flex flex-row items-center justify-between px-4">
      <div className="flex flex-row gap-2 items-start flex-nowrap">
        <div className="flex flex-col gap-2 items-start">
          <div className="flex flex-row gap-2 items-start justify-start">
            <AuditIcon audit={audit} className="size-4 text-gray-500 z-20" />
            {created_by && <UserProfileCard user={created_by} />}
          </div>
        </div>
        <div className="flex flex-col gap-2 items-start">
          <div className="flex flex-row gap-2 items-start justify-start text-wrap">
            <p className="text-xs  text-gray-500 text-wrap">
              <span>{message}</span>
              <span className="text-[8px]  text-gray-500 mx-2">•</span>
              <Tooltip delayDuration={500}>
                <TooltipTrigger asChild>
                  <span className="text-xs  text-gray-500  text-nowrap">
                    {dayjs(created_at).fromNow()}
                  </span>
                </TooltipTrigger>
                <TooltipContent className="bg-white rounded px-2 py-2 border border-slate-300 z-50 text-xs">
                  <div className="text-xs  text-gray-500 text-nowrap">
                    {dayjs(created_at).format('MMM D, YYYY h:mm A')}
                  </div>
                </TooltipContent>
              </Tooltip>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuditLine;
